(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcl-site-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTclMobileMenu = () => {
      const header = document.querySelector('.tcl-site-header');
      if (!header || header.dataset.mobileMenuReady === 'true') return;
      header.dataset.mobileMenuReady = 'true';

      const openButton = header.querySelector('.tcl-mobile-menu-button');
      const drawer = header.querySelector('#TclMobileMenu');
      const closeButton = header.querySelector('.tcl-mobile-menu__close');
      if (!openButton || !drawer || !closeButton) return;

      const closeMenu = () => {
        drawer.hidden = true;
        openButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('tcl-menu-open');
      };

      const openMenu = () => {
        drawer.hidden = false;
        openButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('tcl-menu-open');
      };

      openButton.addEventListener('click', openMenu);
      closeButton.addEventListener('click', closeMenu);
      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) closeMenu();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !drawer.hidden) closeMenu();
      });
    };

    const initTclSearchSuggestions = () => {
      const header = document.querySelector('.tcl-site-header');
      if (!header || header.dataset.searchReady === 'true') return;
      header.dataset.searchReady = 'true';

      const form = header.querySelector('.tcl-search');
      const input = header.querySelector('#TclSearch');
      const panel = header.querySelector('#TclSearchSuggestions');
      if (!form || !input || !panel) return;

      let timer;
      let controller;

      const money = (cents) => {
        try {
          return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format((Number(cents) || 0) / 100);
        } catch (e) {
          return '€' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',');
        }
      };

      const escapeHtml = (value = '') => String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');

      const hide = () => {
        panel.hidden = true;
        panel.innerHTML = '';
      };

      const render = (query, products) => {
        if (!products.length) {
          panel.innerHTML = `<div class="tcl-search-suggestions__empty">Geen producten gevonden voor <strong>${escapeHtml(query)}</strong>.</div>
            <a class="tcl-search-suggestions__all" href="${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(query)}">Bekijk alle zoekresultaten →</a>`;
          panel.hidden = false;
          return;
        }

        const items = products.map((product) => {
          const image = product.image || product.featured_image || '';
          const imageHtml = image
            ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">`
            : '';
          const price = product.price != null ? money(product.price) : '';
          return `<a class="tcl-search-suggestion" href="${escapeHtml(product.url)}">
            <span class="tcl-search-suggestion__image">${imageHtml}</span>
            <span class="tcl-search-suggestion__title">${escapeHtml(product.title)}</span>
            <span class="tcl-search-suggestion__price">${escapeHtml(price)}</span>
          </a>`;
        }).join('');

        panel.innerHTML = `<div class="tcl-search-suggestions__heading">Producten</div>
          <div class="tcl-search-suggestions__list">${items}</div>
          <a class="tcl-search-suggestions__all" href="/search?q=${encodeURIComponent(query)}">Bekijk alle resultaten voor “${escapeHtml(query)}” →</a>`;
        panel.hidden = false;
      };

      const search = async () => {
        const query = input.value.trim();
        if (query.length < 2) {
          hide();
          return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        try {
          const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('search');
          const data = await response.json();
          const products = data?.resources?.results?.products || [];
          render(query, products);
        } catch (error) {
          if (error.name !== 'AbortError') hide();
        }
      };

      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(search, 180);
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && panel.innerHTML) panel.hidden = false;
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) hide();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') hide();
      });
    };

    document.addEventListener('DOMContentLoaded', () => {
      initTclMobileMenu();
      initTclSearchSuggestions();
    });
    document.addEventListener('shopify:section:load', () => {
      initTclMobileMenu();
      initTclSearchSuggestions();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
